"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CalendarEmptyImage = require("./CalendarEmptyImage");
Object.keys(_CalendarEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CalendarEmptyImage[key];
    }
  });
});
var _ChartEmptyImage = require("./ChartEmptyImage");
Object.keys(_ChartEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChartEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChartEmptyImage[key];
    }
  });
});
var _DataEmptyImage = require("./DataEmptyImage");
Object.keys(_DataEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DataEmptyImage[key];
    }
  });
});
var _FileEmptyImage = require("./FileEmptyImage");
Object.keys(_FileEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FileEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FileEmptyImage[key];
    }
  });
});
var _MessageEmptyImage = require("./MessageEmptyImage");
Object.keys(_MessageEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MessageEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MessageEmptyImage[key];
    }
  });
});
var _UploadEmptyImage = require("./UploadEmptyImage");
Object.keys(_UploadEmptyImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UploadEmptyImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UploadEmptyImage[key];
    }
  });
});